import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-score-history-graph',
  templateUrl: './score-history-graph.component.html',
  styleUrls: ['./score-history-graph.component.scss']
})
export class ScoreHistoryGraphComponent implements OnInit {

  constructor() { }

    // lineChart
    public lineChartData:Array<any> = [
      {
        data: [Math.floor(Math.random()*100), Math.floor(Math.random()*100), Math.floor(Math.random()*100), Math.floor(Math.random()*100)],
        label: 'Score',
        lineTension: 0.1,
        fill:false
      }
    ];
    public lineChartLabels:Array<any> = ['Q3 2017', 'Q4 2017', 'Q1 2018', 'Q2 2018'];
    public lineChartOptions:any = {
      responsive: false,
      scales: {
        xAxes: [{
            scaleLabel: {
                display: false,
            },
            gridLines: {
                display: false,
                drawTicks: false
            },
            ticks: {
                display: false
            }
        }],
        yAxes: [{
            scaleLabel: {
                display: false
            },
            gridLines: {
                display: false,
                drawTicks: false
            },
            ticks: {
                display: false
            }
        }]
      },
    };
    public lineChartColors:Array<any> = [
      { // grey
        backgroundColor: 'rgba(148,159,177,0.2)',
        borderColor: 'rgba(148,159,177,1)',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)'
      }
    ];
    public lineChartLegend = false;
    public lineChartType = 'line';

  ngOnInit() {
  }

    public randomize():void {
      const _lineChartData:Array<any> = new Array(this.lineChartData.length);
      for (let i = 0; i < this.lineChartData.length; i++) {
        _lineChartData[i] = {data: new Array(this.lineChartData[i].data.length), label: this.lineChartData[i].label};
        for (let j = 0; j < this.lineChartData[i].data.length; j++) {
          _lineChartData[i].data[j] = Math.floor((Math.random() * 100) + 1);
        }
      }
      this.lineChartData = _lineChartData;
    }

    // events
    public chartClicked(e:any):void {
      console.log(e);
    }

    public chartHovered(e:any):void {
      console.log(e);
    }
}
